export default __webpack_public_path__ + "static/media/gate.8fee7dda.jpeg";